import BackgroundSection from "components/backgrounds/BackgroundSection";
import FormFieldSelect from "components/campos/select";
import Heading from "components/heading/Heading";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import Label from "componentsTemplate/Label/Label";
import Select from "componentsTemplate/Select/Select";
import { set } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getGroupCities, getGroupCitiesFilteredUser, getGroupCitiesMissing, postGroupCitiesMissing } from "services/GroupCityService";
import { getInstitutional, InstitutionalResponse } from "services/PageService";
import { showToastError, showToastSuccess, showToastWarning } from "utils/toasts";

const GroupCitiesMissing: React.FC = () => {

  const navigate = useNavigate();
  const urlBase = process.env.REACT_APP_BACKEND_API_URL + '/storage/images/institutional/banners/';
  const [institutional, setInstitutional] = useState<InstitutionalResponse | null>(null);
  const [cities, setCities] = useState<any[]>([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);
  
  const [needPrimaryCity, setNeedPrimaryCity] = useState<boolean>(false);
  const [primaryCity, setPrimaryCity] = useState<any | null>(null);

  const [secondaryCities, setSecondaryCities] = useState<any[]>([]);
  const [secondaryCitiesMissingResponse, setSecondaryCitiesMissingResponse] = useState<any | null>(null); 
  const [limitSecondaryCities, setLimitSecondaryCities] = useState<number>(0);

  const fetchData = async () => {
    try {
      // const data = await getInstitutional(3);
      // setInstitutional(data);

      const citiesMissing = await getGroupCitiesMissing();

      if (citiesMissing.has_primary_city && citiesMissing.missing_cities.length == 0) {
        navigate('/');
        showToastWarning('Você já possui todos os grupos de cidades disponíveis.');
      }

      setNeedPrimaryCity(!citiesMissing.has_primary_city);
      setSecondaryCitiesMissingResponse(citiesMissing.missing_cities);

      if (citiesMissing.missing_cities.length > 0) {
        // preciso somar todas as propriedades number_missing_cities dentro do array missing_cities
        const limit = citiesMissing.missing_cities.reduce(
                        (acc: number, item: any) => acc + item.number_missing_cities, 0);

        setLimitSecondaryCities(limit);
      }

      const cities = await getGroupCitiesFilteredUser();
      setCities(cities);

    } catch (error) {
      // Lidar com erros, se necessário
    } finally {
      setLoading(false);
    }
  };

  const changeCitySelected = (cityId: number) => {
    if (cityId == primaryCity) {
      return;
    }

    if (secondaryCities.includes(cityId)) {
      setSecondaryCities(secondaryCities.filter((city) => city !== cityId));
    } else {
      if (secondaryCities.length < limitSecondaryCities) {
        setSecondaryCities([...secondaryCities, cityId]);
      }
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setSecondaryCities(secondaryCities.filter((city) => city != primaryCity));
  }, [primaryCity]); 
  
  const submit = async () => {
    try {
      if (needPrimaryCity && !primaryCity) {
        showToastError("Escolha o grupo de cidades principal");
        return;
      }

      if (secondaryCities.length != limitSecondaryCities) {
        showToastError("Ainda há grupos de cidades que podem ser selecionados")
        return;
      }

      let data : any = {
        secondary_cities: secondaryCities
      }

      if (needPrimaryCity) {
        data = {
          ...data,
          primary_city: primaryCity
        }
      }

      const response = await postGroupCitiesMissing(data);

      if (response) {
        showToastSuccess('Grupos de cidades salvos com sucesso!');
        navigate('/');
      }

    } catch (error) {
      console.error('Erro ao salvar as regiões', error);
    } finally {
      setLoadingSubmit(false);
    }

  }

  const getClassCityBadge = (cityId : any) => {
    if (cityId == primaryCity) {
      return 'bg-gray-50'
    } else if (secondaryCities.includes(cityId)) {
      return 'bg-primary-100';
    } else {
      return 'bg-gray-100';
    }
     
  }

  return (
    <div className={`nc-LayoutPage relative`}>
      <div className={`absolute h-full top-0 left-0 right-0 w-full bg-primary-100 bg-opacity-25`}/>
        <div className="container relative sm:py-10">
          <div className="p-1 mx-auto bg-white rounded-xl sm:rounded-3xl lg:rounded-[40px] shadow-lg sm:p-10 lg:p-16 flex flex-col max-h-[90vh]">

            <Heading isCenter desc="Notamos que você ainda pode adicionar mais grupos de cidades aos seus acessos.">
              Uma ótima notícia para você!
            </Heading>

            <hr />
              {
                loading ? (
                    <div className="spinner border-primary-600 my-20"></div>
                ) : (
                  <>
                    <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
                      {
                        needPrimaryCity && (
                          <div className="mt-10 w-full flex justify-center items-center flex-shrink-0">
                            <div className="w-3/4">
                              <Label>{'Defina o seu grupo de cidades principal'}</Label>
                              <Select
                                className="mt-3"
                                style={{ borderRadius: "9999px" }}
                                value={primaryCity || ""}
                                onChange={(e) => setPrimaryCity(e.target.value)}
                              >
                                <option value="">Selecione</option>
                                {cities
                                  .sort((a, b) => a.name > b.name ? 1 : -1)
                                  .map((city) => (
                                  <option key={city.id} value={city.id}>
                                    {city.name}
                                  </option>
                                ))}
                              </Select>
                            </div>
                          </div>
                        )
                      }

                      {
                        (secondaryCitiesMissingResponse &&  secondaryCitiesMissingResponse.length > 0) && (
                          <div className="w-full flex justify-center mt-10 flex-1 min-h-0 flex flex-col items-center">
                            <div className="w-3/4 flex flex-col min-h-0">
                              <Label className="mt-5 flex-shrink-0">
                                {'Escolha os outro grupos de cidades que você deseja'}  
                                  <span className="text-primary-100"> ({secondaryCities.length} de {limitSecondaryCities})</span>
                              </Label>
      
                              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 mt-5 mb-5 overflow-y-auto max-h-[45vh] min-h-0 pr-1">
                                {cities
                                  .sort((a, b) => a.name > b.name ? 1 : -1)
                                  .map((city) => (
                                  <div key={city.id} 
                                    className={`py-2 ${getClassCityBadge(city.id)} rounded-lg flex-shrink-0 ${city.id == primaryCity ? '' : 'cursor-pointer'}`} 
                                    onClick={() => changeCitySelected(city.id)}
                                  >
                                    <div className="flex items-center justify-center">
                                      <h3 className={`text-lg font-semibold capitalize ${city.id == primaryCity ? 'text-gray-400' : ''}`}>{city.name.toLowerCase()}</h3>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )
                      }
                    </div>

                    <div className="flex justify-end px-40 flex-shrink-0 pt-4 border-t border-gray-100 mt-4">
                      <ButtonPrimary
                        className="my-4 w-60"
                        type="button"
                        onClick={() => submit()}
                        disabled={loadingSubmit}
                      >
                        Salvar
                      </ButtonPrimary>
                    </div>
                  </>
                )
              }
          </div>
        </div>
      </div>
    );
};

export default GroupCitiesMissing;
